var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgPlaceholderWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 70C14.8333 70 13.25 69.3611 11.9167 68.0833C10.6389 66.75 10 65.1667 10 63.3333V16.6667C10 14.8333 10.6389 13.2778 11.9167 12C13.25 10.6667 14.8333 10 16.6667 10H63.3333C65.1667 10 66.7222 10.6667 68 12C69.3333 13.2778 70 14.8333 70 16.6667V63.3333C70 65.1667 69.3333 66.75 68 68.0833C66.7222 69.3611 65.1667 70 63.3333 70H16.6667ZM16.6667 63.3333H63.3333V16.6667H16.6667V63.3333ZM20 56.6667H60L47.5 40L37.5 53.3333L30 43.3333L20 56.6667ZM16.6667 63.3333V16.6667V63.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPlaceholderWhite);
export default __webpack_public_path__ + "static/media/imgPlaceholderWhite.78b403ccded3e91d3ea10dd14226e176.svg";
export { ForwardRef as ReactComponent };